import { render, staticRenderFns } from "./tiscFooter.vue?vue&type=template&id=3ed27006&scoped=true&"
import script from "./tiscFooter.vue?vue&type=script&lang=js&"
export * from "./tiscFooter.vue?vue&type=script&lang=js&"
import style0 from "./tiscFooter.vue?vue&type=style&index=0&id=3ed27006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed27006",
  null
  
)

export default component.exports